import { createContext, FunctionComponent, useContext, useState } from 'react';

interface ServiceContextType {
    isRegister: boolean;
    isSuccess: boolean;
    packageName: string;
    setIsSuccess: (state: boolean) => void;
    setPackageName: (state: string) => void;
    setIsRegister: (state: boolean) => void;
}

const initState: ServiceContextType = {
    packageName: '',
    isSuccess: false,
    isRegister: false,
    setIsSuccess: () => null,
    setIsRegister: () => null,
    setPackageName: () => null,
};

const ServiceContext = createContext<ServiceContextType>(initState);

export const useServiceManager = (): ServiceContextType => useContext(ServiceContext);

interface ProviderProps {}

const UseService: FunctionComponent<ProviderProps> = (props) => {
    const [isRegister, setIsRegister] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [packageName, setPackageName] = useState<string>('');

    return (
        <ServiceContext.Provider
            value={{
                isRegister,
                packageName,
                isSuccess,
                setIsSuccess,
                setIsRegister,
                setPackageName,
            }}
        >
            {props.children}
        </ServiceContext.Provider>
    );
};

// export function withServiceManager<P>(WrappedComponent: FunctionComponent): FunctionComponent<P & ProviderProps> {
//     return (props) => {
//         return (
//             <Provider >
//                 <WrappedComponent {...props} />
//             </Provider>
//         );
//     };
// }

export default UseService;
